import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { FaCheckCircle } from 'react-icons/fa';

const SuccessPage: React.FC = () => {
  // Generate a random booking reference
  const bookingReference = `MH${Math.floor(100000 + Math.random() * 900000)}`;

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <FaCheckCircle className="mx-auto h-16 w-16 text-green-500" />
          <h1 className="mt-4 text-3xl font-bold text-gray-900">Booking Confirmed!</h1>
          <p className="mt-2 text-lg text-gray-600">
            Thank you for booking with Mikhael Homestay.
          </p>
          <div className="mt-8 bg-green-50 p-6 rounded-lg">
            <p className="text-gray-700">Your booking reference:</p>
            <p className="text-2xl font-bold text-gray-900 mt-1">{bookingReference}</p>
            <p className="mt-4 text-sm text-gray-600">
              A confirmation email has been sent to your email address.
            </p>
          </div>
          <div className="mt-8 space-y-4">
            <p className="text-gray-700">
              We're looking forward to welcoming you to Mikhael Homestay!
            </p>
            <p className="text-gray-700">
              If you have any questions before your stay, please don't hesitate to contact us.
            </p>
          </div>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              Return to Home
            </Link>
            <Link
              to="/house-rules"
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
              View House Rules
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SuccessPage;
